import IntlMessageFormat from 'intl-messageformat';

export const isJSExpression = (obj = '') => {
  if (obj && typeof obj === 'object' && obj.type === 'JSExpression') {
    return true;
  }
  return false;
};

/**
 * Builds the handler used to format internationalized strings
 * @param {*} locale locale identifier, e.g. zh-CN, en-US
 * @param {*} messages message pack of the locale
 */
export const generateI18n = (locale = 'zh-CN', messages = {}) => {
  return function (key, values = {}) {
    if (!messages || !messages[key]) return '';
    const formater = new IntlMessageFormat(messages[key], locale);
    return formater.format(values);
  };
};
